export default __webpack_public_path__ + "static/media/meeting.e6c1cd4d.svg";